import React from 'react';
const headers = {
  consolidated: {
    regular: claim => [{
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$busine;
        return ((_r$data$object$busine = r.data.object.business_unit) === null || _r$data$object$busine === void 0 ? void 0 : _r$data$object$busine.name) || '';
      },
      valueFn: r => {
        var _r$data$object$busine2;
        return ((_r$data$object$busine2 = r.data.object.business_unit) === null || _r$data$object$busine2 === void 0 ? void 0 : _r$data$object$busine2.name) || '';
      }
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_;
        return ((_r$data$object$claim_ = r.data.object.claim_project_report) === null || _r$data$object$claim_ === void 0 ? void 0 : _r$data$object$claim_.project_name) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_2;
        return ((_r$data$object$claim_2 = r.data.object.claim_project_report) === null || _r$data$object$claim_2 === void 0 ? void 0 : _r$data$object$claim_2.project_name) || '';
      }
    }, {
      text: 'Project Type',
      cellType: 'ProjectTypeDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_3;
        return ((_r$data$object$claim_3 = r.data.object.claim_project_report) === null || _r$data$object$claim_3 === void 0 ? void 0 : _r$data$object$claim_3.program_type) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_4;
        return ((_r$data$object$claim_4 = r.data.object.claim_project_report) === null || _r$data$object$claim_4 === void 0 ? void 0 : _r$data$object$claim_4.program_type) || '';
      }
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      cellType: 'text',
      disabled: true,
      translateValue: true,
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => r.data.object.rate_type || ''
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, {
      text: 'Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => {
        var _r$data$object$fragme;
        return ((_r$data$object$fragme = r.data.object.fragmentable) === null || _r$data$object$fragme === void 0 ? void 0 : _r$data$object$fragme.name) || '';
      }
    }, {
      text: 'Paye Number',
      fieldName: 'paye_ref_number',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.paye_ref_number,
      valueFn: r => {
        var _r$data$object$fragme2;
        return ((_r$data$object$fragme2 = r.data.object.fragmentable) === null || _r$data$object$fragme2 === void 0 ? void 0 : _r$data$object$fragme2.paye_ref_number) || '';
      }
    }, {
      text: 'Description of Activity',
      fieldName: 'description_of_activity',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.description_of_activity,
      valueFn: r => {
        var _r$data$object$fragme3;
        return ((_r$data$object$fragme3 = r.data.object.fragmentable) === null || _r$data$object$fragme3 === void 0 ? void 0 : _r$data$object$fragme3.description_of_activity) || '';
      }
    }, {
      text: '3rd Party Staff Provider',
      cellType: 'StaffProviderDropdown',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.staff_provider.name,
      valueFn: r => {
        var _r$data$object$fragme4;
        return ((_r$data$object$fragme4 = r.data.object.fragmentable) === null || _r$data$object$fragme4 === void 0 || (_r$data$object$fragme4 = _r$data$object$fragme4.staff_provider) === null || _r$data$object$fragme4 === void 0 ? void 0 : _r$data$object$fragme4.name) || '';
      }
    }, {
      text: 'Total Cost (£)',
      fieldName: 'total',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => {
        var _r$data$object$total;
        return (_r$data$object$total = r.data.object.total) !== null && _r$data$object$total !== void 0 ? _r$data$object$total : '';
      }
    }, claim.is_external_workers_rate_reduction_required ? {
      text: 'Reduction Factor',
      fieldName: 'reduction_rate_percentage',
      disabled: true,
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.reduction_rate_percentage),
      valueFn: r => r.data.object.reduction_rate_percentage != null ? "".concat(Number(r.data.object.reduction_rate_percentage).toFixed(1), "%") : ''
    } : null, claim.is_external_workers_rate_reduction_required ? {
      text: 'Eligible Total',
      fieldName: 'eligible_total_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_total_amount),
      valueFn: r => {
        var _r$data$object$eligib;
        return (_r$data$object$eligib = r.data.object.eligible_total_amount) !== null && _r$data$object$eligib !== void 0 ? _r$data$object$eligib : '';
      }
    } : null, {
      width: '90px',
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => {
        var _r$data$object$capita;
        return (_r$data$object$capita = r.data.object.capitalised_costs) !== null && _r$data$object$capita !== void 0 ? _r$data$object$capita : '';
      }
    }, {
      width: '90px',
      text: 'EPW Confirmation',
      fieldName: 'externally_provided_worker',
      cellType: 'checkbox',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.externally_provided_worker,
      valueFn: r => {
        var _r$data$object$fragme5;
        return (_r$data$object$fragme5 = r.data.object.fragmentable) !== null && _r$data$object$fragme5 !== void 0 && _r$data$object$fragme5.externally_provided_worker ? '✓' : '';
      }
    }, {
      text: 'Connected Party',
      fieldName: 'connected_party',
      cellType: 'checkbox',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.connected_party,
      valueFn: r => {
        var _r$data$object$fragme6;
        return (_r$data$object$fragme6 = r.data.object.fragmentable) !== null && _r$data$object$fragme6 !== void 0 && _r$data$object$fragme6.connected_party ? '✓' : '';
      }
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? "".concat(Number(r.data.object.direct_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? "".concat(Number(r.data.object.indirect_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? "".concat(Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1), "%") : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? "".concat(Number(r.data.object.eligible_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Allocation',
      fieldName: 'allocation',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.allocation,
      valueFn: r => {
        var _r$data$object$fragme7;
        return ((_r$data$object$fragme7 = r.data.object.fragmentable) === null || _r$data$object$fragme7 === void 0 ? void 0 : _r$data$object$fragme7.allocation) != null ? "".concat(Number(r.data.object.fragmentable.allocation).toFixed(1), "%") : '';
      }
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => {
        var _r$data$object$rnd_am;
        return (_r$data$object$rnd_am = r.data.object.rnd_amount) !== null && _r$data$object$rnd_am !== void 0 ? _r$data$object$rnd_am : '';
      }
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => {
        var _r$data$object$pnl_ex;
        return (_r$data$object$pnl_ex = r.data.object.pnl_expenditure) !== null && _r$data$object$pnl_ex !== void 0 ? _r$data$object$pnl_ex : '';
      }
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => {
        var _r$data$object$s1308_;
        return (_r$data$object$s1308_ = r.data.object.s1308_claim) !== null && _r$data$object$s1308_ !== void 0 ? _r$data$object$s1308_ : '';
      }
    }].filter(Boolean),
    realtime: claim => [{
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$busine3;
        return ((_r$data$object$busine3 = r.data.object.business_unit) === null || _r$data$object$busine3 === void 0 ? void 0 : _r$data$object$busine3.name) || '';
      },
      valueFn: r => {
        var _r$data$object$busine4;
        return ((_r$data$object$busine4 = r.data.object.business_unit) === null || _r$data$object$busine4 === void 0 ? void 0 : _r$data$object$busine4.name) || '';
      }
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_5;
        return ((_r$data$object$claim_5 = r.data.object.claim_project_report) === null || _r$data$object$claim_5 === void 0 ? void 0 : _r$data$object$claim_5.project_name) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_6;
        return ((_r$data$object$claim_6 = r.data.object.claim_project_report) === null || _r$data$object$claim_6 === void 0 ? void 0 : _r$data$object$claim_6.project_name) || '';
      }
    }, {
      text: 'Project Type',
      cellType: 'ProjectTypeDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_7;
        return ((_r$data$object$claim_7 = r.data.object.claim_project_report) === null || _r$data$object$claim_7 === void 0 ? void 0 : _r$data$object$claim_7.program_type) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_8;
        return ((_r$data$object$claim_8 = r.data.object.claim_project_report) === null || _r$data$object$claim_8 === void 0 ? void 0 : _r$data$object$claim_8.program_type) || '';
      }
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      cellType: 'text',
      disabled: true,
      translateValue: true,
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => r.data.object.rate_type || ''
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, {
      text: 'Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => {
        var _r$data$object$fragme8;
        return ((_r$data$object$fragme8 = r.data.object.fragmentable) === null || _r$data$object$fragme8 === void 0 ? void 0 : _r$data$object$fragme8.name) || '';
      }
    }, {
      text: 'Paye Number',
      fieldName: 'paye_ref_number',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.paye_ref_number,
      valueFn: r => {
        var _r$data$object$fragme9;
        return ((_r$data$object$fragme9 = r.data.object.fragmentable) === null || _r$data$object$fragme9 === void 0 ? void 0 : _r$data$object$fragme9.paye_ref_number) || '';
      }
    }, {
      text: 'Description of Activity',
      fieldName: 'description_of_activity',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.description_of_activity,
      valueFn: r => {
        var _r$data$object$fragme0;
        return ((_r$data$object$fragme0 = r.data.object.fragmentable) === null || _r$data$object$fragme0 === void 0 ? void 0 : _r$data$object$fragme0.description_of_activity) || '';
      }
    }, {
      text: '3rd Party Staff Provider',
      cellType: 'StaffProviderDropdown',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.staff_provider.name,
      valueFn: r => {
        var _r$data$object$fragme1;
        return ((_r$data$object$fragme1 = r.data.object.fragmentable) === null || _r$data$object$fragme1 === void 0 || (_r$data$object$fragme1 = _r$data$object$fragme1.staff_provider) === null || _r$data$object$fragme1 === void 0 ? void 0 : _r$data$object$fragme1.name) || '';
      }
    }, {
      text: 'Total Cost (£)',
      fieldName: 'total',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => {
        var _r$data$object$total2;
        return (_r$data$object$total2 = r.data.object.total) !== null && _r$data$object$total2 !== void 0 ? _r$data$object$total2 : '';
      }
    }, claim.is_external_workers_rate_reduction_required ? {
      text: 'Reduction Factor',
      fieldName: 'reduction_rate_percentage',
      disabled: true,
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.reduction_rate_percentage),
      valueFn: r => r.data.object.reduction_rate_percentage != null ? "".concat(Number(r.data.object.reduction_rate_percentage).toFixed(1), "%") : ''
    } : null, claim.is_external_workers_rate_reduction_required ? {
      text: 'Eligible Total',
      fieldName: 'eligible_total_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_total_amount),
      valueFn: r => {
        var _r$data$object$eligib2;
        return (_r$data$object$eligib2 = r.data.object.eligible_total_amount) !== null && _r$data$object$eligib2 !== void 0 ? _r$data$object$eligib2 : '';
      }
    } : null, {
      width: '90px',
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => {
        var _r$data$object$capita2;
        return (_r$data$object$capita2 = r.data.object.capitalised_costs) !== null && _r$data$object$capita2 !== void 0 ? _r$data$object$capita2 : '';
      }
    }, {
      width: '90px',
      text: 'EPW Confirmation',
      fieldName: 'externally_provided_worker',
      cellType: 'checkbox',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.externally_provided_worker,
      valueFn: r => {
        var _r$data$object$fragme10;
        return (_r$data$object$fragme10 = r.data.object.fragmentable) !== null && _r$data$object$fragme10 !== void 0 && _r$data$object$fragme10.externally_provided_worker ? '✓' : '';
      }
    }, {
      text: 'Connected Party',
      fieldName: 'connected_party',
      cellType: 'checkbox',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.connected_party,
      valueFn: r => {
        var _r$data$object$fragme11;
        return (_r$data$object$fragme11 = r.data.object.fragmentable) !== null && _r$data$object$fragme11 !== void 0 && _r$data$object$fragme11.connected_party ? '✓' : '';
      }
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? "".concat(Number(r.data.object.direct_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? "".concat(Number(r.data.object.indirect_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? "".concat(Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1), "%") : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? "".concat(Number(r.data.object.eligible_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Allocation',
      fieldName: 'allocation',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.allocation,
      valueFn: r => {
        var _r$data$object$fragme12;
        return ((_r$data$object$fragme12 = r.data.object.fragmentable) === null || _r$data$object$fragme12 === void 0 ? void 0 : _r$data$object$fragme12.allocation) != null ? "".concat(Number(r.data.object.fragmentable.allocation).toFixed(1), "%") : '';
      }
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => {
        var _r$data$object$rnd_am2;
        return (_r$data$object$rnd_am2 = r.data.object.rnd_amount) !== null && _r$data$object$rnd_am2 !== void 0 ? _r$data$object$rnd_am2 : '';
      }
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => {
        var _r$data$object$pnl_ex2;
        return (_r$data$object$pnl_ex2 = r.data.object.pnl_expenditure) !== null && _r$data$object$pnl_ex2 !== void 0 ? _r$data$object$pnl_ex2 : '';
      }
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => {
        var _r$data$object$s1308_2;
        return (_r$data$object$s1308_2 = r.data.object.s1308_claim) !== null && _r$data$object$s1308_2 !== void 0 ? _r$data$object$s1308_2 : '';
      }
    }].filter(Boolean)
  }
};
export const staffingCostFragmentTableSettings = {
  headers
};